import { Box, Typography, Paper, Switch, FormControlLabel } from '@mui/material';

export default function NotificationSettings() {
  return (
    <Box>
      <Typography sx={{ fontWeight: 700, fontSize: 16, mb: 2 }}>Email Notifications</Typography>

      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <FormControlLabel control={<Switch defaultChecked size="small" />}
            label={<Typography sx={{ fontSize: 13 }}>New store registration</Typography>} />
          <FormControlLabel control={<Switch defaultChecked size="small" />}
            label={<Typography sx={{ fontSize: 13 }}>Contract signed</Typography>} />
          <FormControlLabel control={<Switch defaultChecked size="small" />}
            label={<Typography sx={{ fontSize: 13 }}>Payment overdue (3+ days)</Typography>} />
          <FormControlLabel control={<Switch size="small" />}
            label={<Typography sx={{ fontSize: 13 }}>Device offline alert</Typography>} />
          <FormControlLabel control={<Switch size="small" />}
            label={<Typography sx={{ fontSize: 13 }}>Price change requests</Typography>} />
        </Box>
      </Paper>

      <Typography sx={{ fontWeight: 700, fontSize: 16, mb: 1, mt: 3 }}>Email Configuration</Typography>
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, fontSize: 13, color: '#555' }}>
        <p>Sender: <code>support@digntec.com</code> (Gmail SMTP)</p>
        <p style={{ fontSize: 12, color: '#888', marginTop: 8 }}>
          Email settings are managed in server .env (EMAIL_USER, EMAIL_PASS)
        </p>
      </Paper>
    </Box>
  );
}
